<template>
  <FormTemplate>
    <template v-slot:form-body>
      <v-form ref="formArea" @submit.prevent="saveForm">
        <v-row>
          <v-col cols="12" md="3">
            <label for="text">Rubro</label>
          </v-col>

          <v-col cols="12" md="9" class="pb-0">
            <v-text-field
              id="text"
              v-model="area.text"
              outlined
              dense
              placeholder="Rubro"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <label for="description">Descripción</label>
          </v-col>

          <v-col cols="12" md="9" class="pb-0">
            <v-textarea
              id="description"
              v-model="area.description"
              outlined
              dense
              placeholder="Descripción corta del servicio"
              rows="4"
              :rules="required"
            ></v-textarea>
          </v-col>

          <v-col cols="12" md="3">
            <label for="urlText">URL</label>
          </v-col>

          <v-col cols="12" md="9" class="pb-0">
            <v-text-field
              id="urlText"
              v-model="area.urlText"
              outlined
              dense
              placeholder="URL a redireccionar"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <label for="icon">Icon</label>
          </v-col>

          <v-col cols="12" md="9" class="pb-0">
            <v-file-input
              id="icon"
              v-model="image"
              outlined
              prepend-icon=""
              dense
              placeholder="Elige una imagen"
              @change="onFileChange"
            ></v-file-input>
          </v-col>

          <v-col v-if="url || areaEdited" cols="12" class="pb-0">
            <div class="icon-service center-sub-items">
              <img draggable="false" :src="url || loadImage(area.icon)" :alt="area.text" />
            </div>
          </v-col>

          <v-col offset-md="3" cols="9">
            <v-btn type="submit" :disabled="loading" :loading="loading" color="primary"> Guardar </v-btn>
            <v-btn type="reset" @click="reset" class="mx-2" outlined> Limpiar </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </FormTemplate>
</template>

<script>
import FormTemplate from '@/components/forms/FormTemplate.vue'
import { loadAPIImage } from '@/utils/images'

export default {
  components: {
    FormTemplate,
  },
  props: {
    areaEdited: Object,
    loading: Boolean,
  },
  data() {
    return {
      required: [v => !!v || 'Requerido'],
      url: '',
      image: null,
      area: this.areaEdited
        ? { ...this.areaEdited }
        : {
            text: '',
            urlText: '',
            description: '',
          },
    }
  },
  methods: {
    validateForm() {
      return this.$refs.formArea.validate()
    },
    reset() {
      this.area.icon = null
      this.area.text = ''
      this.area.urlText = ''
      this.area.description = ''
      this.$refs.formArea.resetValidation()
    },
    saveForm() {
      if (!this.validateForm()) return
      if (this.areaEdited) {
        let DTO = { ...this.area }

        if (this.image) {
          DTO = {
            ...DTO,
            file: this.image,
          }
        }
        // // console.log('actualizar', DTO)
        this.$emit('beforeUpdate', DTO)
      } else {
        const DTO = { ...this.area, icon: this.image }
        // // console.log('crear', DTO)
        this.$emit('beforeCreate', DTO)
      }
    },
    loadImage(src) {
      return loadAPIImage(src)
    },
    onFileChange(e) {
      if (!e) return
      this.url = URL.createObjectURL(e)
    },
  },
}
</script>

<style lang="scss" scoped>
.icon-service {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #00aca0;
  padding: 20px;
}

.icon-service img {
  max-width: 80px;
  max-height: 80px;
}

.center-sub-items {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
